// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const ChangePassword = () => {

   const [text, set_text] = React.useState();

   var content    = [];

   var key_index  = 1;

   const showpass = React.useRef();
   const passtext = React.useRef();
   const password = React.useRef();
   const username = React.useRef();
   const verify   = React.useRef();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      content.push(<p className="ask-henry-body-margin-bottom-x" key={key_index++}>Enter your current password:</p>);
      content.push(<input className="ask-henry-form-input ask-henry-form-password" key={key_index++} placeholder="Current Password. . ." ref={password} type="password" />);

      if (app.state.is_admin) {
         content.push(<p className="ask-henry-body-margin-bottom-x" key={key_index++}>Enter user for whose password you want to change:</p>);
         content.push(<input className="ask-henry-form-input" placeholder="User. . ." key={key_index++} ref={username} type="text" />);
      }

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           {warn}
           {content}
           <p className="ask-henry-body-margin-bottom-x">Enter and verify new password:</p>
           <input className="ask-henry-form-input ask-henry-form-password" placeholder="New Password. . ." ref={passtext} type="password" />
           <input className="ask-henry-form-input ask-henry-form-password" placeholder="Verify Password. . ." ref={verify} type="password" />
           <input className="ask-henry-checkbox" onChange={(e) => build_checkbox_click(e)} ref={showpass} type="checkbox" /> Show passwords
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Change Password</button>
           <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
         </>
      );

   } // build();

   const build_checkbox_click = (e) => {
      const list = document.getElementsByClassName('ask-henry-form-password');
      for (var ith = 0; ith < list.length; ith++) {
         list[ith].type = e.target.checked ? 'text' : 'password';
      }
   }; // build_checkbox_click();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;

      if ((app.state.is_admin && !username.current?.value) || !passtext.current?.value || !verify.current?.value) {
         set_warn('Enter all fields given bellow:');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else if (passtext.current?.value !== verify.current?.value) {
         set_warn('Make sure the new and verify passwords are the same.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }

   } // check();

   const enact = async ({ set_form, set_warn, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      var body     = ''
      + 'username=' + app.state.user_name 
      + '&password=' + password.current?.value
      + '&passtext=' + passtext.current?.value
      + '&passuser=' + (app.state.is_admin ? username.current?.value : app.state.user_name);
      var response = await api.fetch('sys/password', api.post(body), api.token());

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
            // 'The password must be between eight and 20 characters long, must contain at least one upper case character, one lower case character, one number and one of these special characters: ! @ # $ % & * + ?'
         }
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.FINAL);
         var text = response.data.message;
         set_text(text);
         app.set_state('status', text);
      }

   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">{text}</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form build={build} check={check} enact={enact} final={final} title="Change Password" />

} // <ChangePassword />

export default ChangePassword;
